'use client'
import { useState } from 'react'

import { Play } from '@doist/icons/brand'
import { Box, Container, Image, OverlayButton } from '@doist/marketist'

import { useTranslation } from 'app/i18n/client'
import { addProtocol } from 'app/services/contentful/add-protocol-to-url'
import { RenderRichText } from 'app/services/contentful/render-rich-text'
import cn from 'clsx'
import { Alert } from 'components/alert/alert'
import { YouTubeVideo } from 'components/YouTubeVideo/YouTubeVideo'
import { useLocale } from 'next-intl'

import { type VideoBlockProps } from '../types'

import css from './video-block.module.css'

import { SectionHeader } from '@/components/SectionHeader/SectionHeader'

function VideoBlock({ props }: { props: VideoBlockProps }) {
    const { youTubeVideoId, videoThumbnail, callOutAlert, title, subtitle } = props.fields
    const [hasUserInitiatedPlayback, setHasUserInitiatedPlayback] = useState(false)

    const locale = useLocale()
    const { t } = useTranslation(locale, 'productui')

    return (
        <Container>
            {title ? (
                <SectionHeader title={title} subtitle={subtitle} style={{ marginInline: 'auto' }} />
            ) : null}
            <Box className={css.videoWrapper}>
                {!hasUserInitiatedPlayback ? (
                    <>
                        {videoThumbnail?.fields.file ? (
                            <>
                                <Image
                                    src={addProtocol(videoThumbnail?.fields.file?.url)}
                                    alt={videoThumbnail?.fields.description}
                                    className={css.videoThumbnail}
                                    width={1088}
                                    height={612}
                                    priority
                                />
                                <OverlayButton
                                    startIcon={Play}
                                    aria-label={t('play')}
                                    onClick={() => setHasUserInitiatedPlayback(true)}
                                    className={css.overlayButton}
                                >
                                    {t('play')}
                                </OverlayButton>
                            </>
                        ) : null}
                    </>
                ) : (
                    <YouTubeVideo
                        className={css.video}
                        videoID={youTubeVideoId}
                        playerVars={{
                            loop: 0,
                            autoplay: 1,
                            playsinline: 1,
                            mute: 0,
                        }}
                    />
                )}
            </Box>
            {callOutAlert ? (
                <Container width="sm" className={cn('mbs-24', css.alertSection)}>
                    <Alert includeTextWrapper={false}>
                        <RenderRichText>{callOutAlert}</RenderRichText>
                    </Alert>
                </Container>
            ) : null}
        </Container>
    )
}

export { VideoBlock }
